import { PlatformPage } from './PlatformPage'
import { CustomerUsersTab } from './tabs/CustomerUsersTab'

export function CustomerUsersPage() {
  return (
    <PlatformPage
      title="Customer Users"
      description="Look up any customer across all tenants - suspend, impersonate, inspect."
    >
      <CustomerUsersTab />
    </PlatformPage>
  )
}
